import React from "react";
import PropTypes from "prop-types";

import { Button, ButtonGroup } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faGripHorizontal } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "types/store";
import { getIsTile, updateIsTile } from "containers/View/reducer";

import { Menu } from "components/Home/Utils/Utils";

import styles from "./style.module.css";

const ViewTileToggle = () => {
  const dispatch = useDispatch();

  const isTile = useSelector((state) => getIsTile(state));

  return (
    <div className={styles.buttonHolder}>
      <ButtonGroup>
        <Button
          type="secondary"
          style={{ lineHeight: "10px" }}
          active={isTile}
          onClick={() => dispatch(updateIsTile(true))}
          title="Tiles"
        >
          <FontAwesomeIcon icon={faGripHorizontal} />
        </Button>
        <Button
          type="secondary"
          style={{ lineHeight: "10px" }}
          active={!isTile}
          onClick={() => dispatch(updateIsTile(false))}
          title="Table"
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>
      </ButtonGroup>
    </div>
  );
};

const View = ({
  type,
  typeOptions,
  isLoading,
  updateType,
  hideTileToggle,
  hideMenu,
  hideSearch,
  search,
  updateSearch,
  isSettingsView,
  children
}) => {
  const menuTypeOptions = typeOptions.map((text) => ({ text }));

  return (
    <div className={styles.view}>
      {hideMenu !== true && (
        <Menu
          options={menuTypeOptions}
          selectHandler={updateType}
          selected={type}
          search={search}
          searchHandler={hideSearch ? undefined : updateSearch}
          isLoading={isLoading}
        >
          {!hideSearch && !hideTileToggle && <ViewTileToggle />}
        </Menu>
      )}
      <div className={isSettingsView ? styles.settingsViewHolder : styles.viewHolder} id="viewScroll">
        {children}
      </div>
    </div>
  );
};

View.defaultProps = {
  hideSearch: false
};

View.propTypes = {
  // Type of view selected
  type: PropTypes.string,
  // Array of possible view types
  typeOptions: PropTypes.arrayOf(PropTypes.string),
  // Function to update the selected view type
  updateType: PropTypes.func,
  // Determines whether search is hidden
  hideSearch: PropTypes.bool,
  // Function to update search
  updateSearch: PropTypes.func,
  // Determines whether the view is in tile mode
  isTile: PropTypes.bool
};

export default View;
